import ReserveWelcomePackArticleBody from './ReserveWelcomePackArticleBody'
import ReserveVsStudioWelcomePack from './ReserveVsStudioWelcomePack'
import MembershipBenefitsWelcomePack from './MembershipBenefitsWelcomePack'
import JourneyArtisanSupportWelcomePack from './JourneyArtisanSupportWelcomePack'
import BlackKeyAccessWelcomePack from './BlackKeyAccessWelcomePack'
import MemberExpectationsWelcomePack from './MemberExpectationsWelcomePack'
import { extractReserveWelcomePackMasthead } from '../constants/reserveWelcomePack'

/**
 * Renders welcome-pack body for a section (same branching as the former topic-only page).
 */
const WelcomePackTopicContent = ({ section }) => {
  const isReserveVsStudio = section.layout === 'reserve_vs_studio'
  const isMembershipBenefits = section.layout === 'membership_benefits'
  const isJourneyArtisanSupport = section.layout === 'journey_artisan_support'
  const isBlackKeyAccess = section.layout === 'black_key_access'
  const isMemberExpectations = section.layout === 'member_expectations'

  const { hasMasthead, kicker, brand, rest } = extractReserveWelcomePackMasthead(section.body)
  const bodyToRender = hasMasthead ? rest : section.body

  return (
    <>
      {!isReserveVsStudio &&
      !isMembershipBenefits &&
      !isJourneyArtisanSupport &&
      !isBlackKeyAccess &&
      !isMemberExpectations &&
      hasMasthead ? (
        <header className="text-center space-y-4 sm:space-y-5 mb-12 sm:mb-14 max-w-xl mx-auto">
          <p className="text-[11px] sm:text-xs font-medium uppercase tracking-[0.32em] text-black">
            {kicker.toUpperCase()}
          </p>
          <p className="font-AXONALLPrimeSemiBold text-[1.75rem] sm:text-4xl md:text-[2.5rem] uppercase tracking-tight text-black leading-[1.05]">
            {brand.toUpperCase()}
          </p>
          <p className="text-lg sm:text-xl italic text-black font-normal pt-1">{section.title}</p>
        </header>
      ) : null}

      <article className="text-black">
        {isReserveVsStudio ? (
          <ReserveVsStudioWelcomePack />
        ) : isMembershipBenefits ? (
          <MembershipBenefitsWelcomePack />
        ) : isJourneyArtisanSupport ? (
          <JourneyArtisanSupportWelcomePack />
        ) : isBlackKeyAccess ? (
          <BlackKeyAccessWelcomePack />
        ) : isMemberExpectations ? (
          <MemberExpectationsWelcomePack />
        ) : (
          <ReserveWelcomePackArticleBody text={bodyToRender} editorial />
        )}
      </article>
    </>
  )
}

export default WelcomePackTopicContent
